import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import CustomButton from "../../components/Custom-Button/CustomButton";
import Title from "../../components/Title/Title";
import List from "../../components/Horizontal-list/list";
import CircleCard from "../../components/Circle-Card/Circle-Card";

// Sj => Saint Joseph
export default function SaintJ() {

    return (
        <div>
            <NavBar/>
            <Title text={'São José'}/>            
            <CircleCard alt={"Imagem Sao Jose"} imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Paintings/Joseph.jfif"}/>
            <List titleOne={"Patrono da Igreja Católica"} titleTwo={"Padroeiro da Sagrada Família"} titleThree={"Padroeiro dos Trabalhadores"} titleFour={"Padroeiro das Famílias"} titleFive={"O mais eficaz protetor dos moribundos"}/>

            <br/>
            <div className="btn-row">
                <CustomButton text={"Vida de São José"} route={"/SJ-Life"}/>
                <CustomButton text={"Devoções a São José"} route={"/SJ-Dev"}/>
            
                <CustomButton text={"Importância Teológica e Espiritual na Igreja."} route={"/SJ-ITE"}/>
                <CustomButton text={"Documentos Oficiais sobre São José"} route={"/SJ-Docs"}/>
            </div>
            {/* Consertar esta parte também */}
            <br />
            <br />
            <br />
            <Footer/>
        </div>
    )
}